import React, { Component } from 'react';
import { version } from '../../package.json';

import { Scene, View, SwitchLang, Text } from 'core';
import { lang } from 'lang';
import { style, theme, APP_TABS } from 'constants';
import { ActionSheetProvider, AlertProvider, WebBrowserProvider, FilePickerProvider, MediaViewerProvider, TelPickerProvider } from 'core';

import Modal from 'cont/modals';
import AppTab from 'cont/left/AppTabs';
import GroupsList from 'cont/left/GroupsList';
import PMList from 'cont/left/PMList';
import SettingsList from 'cont/left/SettingsList';

import GroupContent from 'cont/middle/GroupContent';
import PMContent from 'cont/middle/PMContent';
import SettingsContent from 'cont/middle/SettingsContent';
import Welcome from './welcome';

import * as actions from 'actions';

const styles = style({
    tabContainer: {
        width: 100,
        borderColor: theme.gray_color_lighten(0.2),
        backgroundColor: theme.gray_color_lighten(0.01),
        borderRightWidth: 0.5,
        alignItems: 'center',
        paddingTop: 40
    },
    left: {
        flex: 0.3,
        borderColor: theme.gray_color_lighten(0.2),
        borderRightWidth: 0.5,
        paddingRight: 1
    }
});
const AppTabs = ({ self }) => (
    <View style={styles.tabContainer}>
        <AppTab name={APP_TABS.SETTINGS} />
        <AppTab name={APP_TABS.GROUPS} />
        <AppTab name={APP_TABS.PM} />
        <SwitchLang color={theme.gray_color_lighten(0.5)} style={{ alignSelf: 'center', marginTop: 'auto' }} self={self} />
        <Text style={{ color: theme.gray_color_alpha(0.4), marginBottom: 5, alignSelf: 'center' }}>v{version.split('.')[0]}</Text>
    </View>
);
const LeftPan = { SETTINGS: SettingsList, GROUPS: GroupsList, PM: PMList };
const ContentPan = { SETTINGS: SettingsContent, GROUPS: GroupContent, PM: PMContent };

export default class Fosol extends Component {
    componentDidMount() {
        document.addEventListener('visibilitychange', this._handleAppStateChange);
    }

    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this._handleAppStateChange);
    }
    _handleAppStateChange = () => {
        actions.showOnline(document.visibilityState === 'visible');
    };
    render() {
        const { selected_tab, route_index, tmp_pm } = this.props;
        const List = LeftPan[selected_tab];
        const Content = (route_index && ContentPan[selected_tab]) || (selected_tab === 'PM' && tmp_pm && ContentPan['PM']) || (() => <Welcome />);
        // eslint-disable-next-line
        const a = <a id="link" target="_blank" />;
        return (
            <Scene key={lang.CODE} style={{ flexDirection: 'row' }}>
                <AppTabs self={this} />
                <View style={styles.left}>
                    <List />
                </View>
                <View style={{ flex: 0.7 }}>
                    <Content />
                </View>
                <Modal />
                {a}
                <WebBrowserProvider />
                <AlertProvider />
                <FilePickerProvider />
                <MediaViewerProvider />
                <TelPickerProvider />
                <ActionSheetProvider />
            </Scene>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fosol.web.js